import React, {FC} from 'react';

import {Colors, Input, Text} from '@optimaxdev/design-system';

import classNames from 'classnames';

import {validateField} from 'libs/success/helpers/helpers';
import {DoctorDetailsType} from 'types/successPage';

import s from './doctorManualSearchContacts.scss';

type PropsType = {
    doctorDetails: DoctorDetailsType;
    onDoctorDetailsChange: (name: string, value: string) => void;
    errors: {[key: string]: string};
};

const INPUTS: {
    name: string;
    label: string;
    type: 'text' | 'password' | 'email' | 'number' | 'tel' | 'date' | 'fax';
}[] = [
    {
        label: 'Phone number',
        name: 'phone',
        type: 'tel',
    },
    {
        label: 'Fax number',
        name: 'fax',
        type: 'fax',
    },
    {
        label: 'Email address',
        name: 'email',
        type: 'email',
    },
];

/**
 * contacts inputs in manually form of finding doctor (TYP Cl)
 */
export const DoctorManualSearchContacts: FC<PropsType> = ({
    doctorDetails,
    errors,
    onDoctorDetailsChange,
}) => {
    const isDesktop = __BUILD_TYPE__ === 'desktop';
    return (
        <div className={classNames(s.label, {[s.desktop]: isDesktop})}>
            <Text as="p" color={Colors.nevada} lineHeight="21px" size="14px">
                Enter <b>at least</b> one contact method:
            </Text>
            {INPUTS.map(item => {
                const value =
                    doctorDetails[
                        item.name as keyof Omit<DoctorDetailsType, 'filling_method' | 'location'>
                    ] || '';
                const error = errors?.[item.name];

                return (
                    <div key={item.name}>
                        <Input
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                onDoctorDetailsChange(event.target.name, event.target.value)
                            }
                            id={item.name}
                            isError={Boolean(error)}
                            isSuccess={validateField(item.name, value)}
                            label={item.label}
                            message={error}
                            name={item.name}
                            size="large"
                            type={item.type}
                            value={value}
                        />
                    </div>
                );
            })}
        </div>
    );
};
